import React from 'react';
import { SpriteRecord } from '../types/sprites';

type Props = {
  sp: SpriteRecord;
  name: string;
  exportMode: boolean;
  checked: boolean;
  onToggleSelected: (id: string) => void;
  onOpen: () => void;
  onDelete?: () => void; // dold om undefined
  onImgError: (sp: SpriteRecord) => (ev: React.SyntheticEvent<HTMLImageElement>) => void;
};

const SpriteCard: React.FC<Props> = ({
  sp, name, exportMode, checked, onToggleSelected, onOpen, onDelete, onImgError
}) => {
  return (
    <div className="library-cell" style={{ display: 'flex', flexDirection: 'column', gap: 6 }} title={name}>
      <div
        className={`library-item ${exportMode ? 'selectable' : ''}`}
        style={{ position:'relative', width:'100%', display:'flex', flexDirection:'column', gap:6, border:'1px solid #2b2b2b', background:'#0b0b0e', padding:8 }}
      >
        {!exportMode && onDelete && (
          <button type="button" className="delete-check" onClick={onDelete} title="Delete" aria-label="Delete">×</button>
        )}

        {exportMode && (
          <button
            type="button"
            className={`select-check ${checked ? 'checked' : ''}`}
            onClick={(e)=>{ e.stopPropagation(); onToggleSelected(sp.id); }}
            aria-pressed={checked}
            title={checked ? 'Selected' : 'Select'}
            style={{
              position:'absolute', top:8, left:8, width:24, height:24, borderRadius:6,
              border:'1px solid #3a3a3a', background: checked ? '#2d6cdf' : '#222',
              color:'#fff', display:'inline-flex', alignItems:'center', justifyContent:'center', zIndex:2
            }}
          >
            {checked ? '✓' : ''}
          </button>
        )}

        <button
          type="button"
          className="library-open"
          onClick={onOpen}
          title={name}
          style={{ display:'block', width:'100%', padding:0, background:'transparent', border:'none', cursor:'pointer', textAlign:'inherit' }}
        >
          <div className="thumb" style={{ width:'100%', aspectRatio:'1/1', background:'#000', display:'flex', alignItems:'center', justifyContent:'center' }}>
            {sp.previewUrl ? (
              <img
                src={sp.previewUrl || sp.__pixelFallback}
                alt={name}
                className="thumb-img"
                loading="lazy"
                decoding="async"
                onError={onImgError(sp)}
                style={{ width:'100%', height:'100%', imageRendering:'pixelated' as any }}
              />
            ) : (
              <div style={{ width: 24, height: 24, opacity: 0.25, border: '1px dashed #666' }} />
            )}
          </div>
        </button>
      </div>

      {/* Titel under kortet */}
      <div className="thumb-title" title={sp.name || 'untitled'} style={{ fontSize:12, color:'var(--ink, #ddd)', textAlign:'center', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', marginTop:6 }}>
        {sp.name || 'untitled'}
      </div>
    </div>
  );
};

export default SpriteCard;